class CountryService {
    getCountryOptions() {
        return [
            {
                id: 1,
                code: 'uk',
                display: 'UK',
                currency: '£',
                currencyCode: 'GBP'
            },
            {
                id: 2,
                code: 'us',
                display: 'US',
                currency: '$',
                currencyCode: 'USD'
            },
            {
                id: 3,
                code: 'au',
                display: 'AU',
                currency: '$',
                currencyCode: 'AUD'
            },
            {
                id: 4,
                code: 'nz',
                display: 'NZ',
                currency: '$',
                currencyCode: 'NZD'
            },
            {
                id: 5,
                code: 'ie',
                display: 'IE',
                currency: '€',
                currencyCode: 'EUR'
            },

        ]
    }
    
    getDisplayNameById(id: number) {
        return this.getCountryOptions().find(c => c.id === id)?.display;
    }
}

export default new CountryService();